<mat-form-field appearance="outline" class="no-line">
    <mat-select class="select" [placeholder]="placeholder" (ngModelChange)="DurationSelected($event)"
        [(ngModel)]="selectedDuration" disableOptionCentering>
        <mat-option *ngFor="let duration of durations" [value]="duration.durationId">
            {{duration.displayValue}}
        </mat-option>
    </mat-select>
</mat-form-field>